import {
    TemplateType,
    TRepoKey
} from '~/components/FlowGallery/types/flow-gallery.types';
import {
    FlowGalleryService,
    IListFlowsRequest
} from '~/services/flow-gallery.service';
import { TemplatesAdapter } from '~/services/adapters/templates.adapter';
import { IApiService } from '~/services/interfaces/IApiService';
import { trackError } from '~/services/logger/error.utils';

export interface IFetchFlowsRequest extends IListFlowsRequest {
    skipMicroService?: boolean;
    repository?: TRepoKey;
}

export class TemplatesService extends TemplatesAdapter {
    flowGalleryService: FlowGalleryService;

    constructor(
        apiService: IApiService,
        flowGalleryService: FlowGalleryService
    ) {
        super(apiService);

        this.flowGalleryService = flowGalleryService;
    }

    async fetchTemplates({
        tags,
        limit = 1000,
        repository = 'flow_gallery',
        skipMicroService,
        ...variables
    }: IFetchFlowsRequest) {
        if (!skipMicroService) {
            try {
                return await this.flowGalleryService.listFlows({
                    tags,
                    limit,
                    ...variables
                });
            } catch (error) {
                trackError({
                    error,
                    message: '[Templates Gallery] Failed to fetch templates',
                    context: { templates_gallery: true }
                });
                return [];
            }
        }

        return super._fetchTemplates({
            filters: {
                type: [TemplateType.Flow],
                tag: tags,
                repository: [repository]
            }
        });
    }
}
